import { ListingRequestCard } from 'app/components/listing-request-card';
import type { Listing } from 'app/types/listing';
import { ListingType } from 'app/types/listing';
import { FeatureType } from 'app/types/recommender';
import { Strategies } from '../../all-listings/components/recommended-listings.utils';
import { DesktopRecommendationSection } from '../../all-listings/components/recommended-listings.large';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function MatchingRequestsDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { matchingRequestsRecommendations, navigation, shouldShowRecommendationSection } = data;
  if (!shouldShowRecommendationSection(matchingRequestsRecommendations)) return null;
  return (
    <DesktopRecommendationSection<Listing>
      horizontalPadding={0}
      strategyProps={{
        strategy: Strategies.UseMatchNeedsWithOffers,
        recommendationType: ListingType.request,
        similarityType: FeatureType.CONTENT,
      }}
      recommendationState={matchingRequestsRecommendations}
      recommendations={matchingRequestsRecommendations.recommendations as Listing[] | undefined}
      onViewAll={() => navigation.navigate('all-listings', { type: ListingType.request })}
      renderItem={(listing) => <ListingRequestCard listing={listing} showUser />}
    />
  );
}
